/**
 * Props for the Pan slot component.
 * @public
 */
export interface PanSlotProps {
  /**
   * Whether the pan is disabled.
   */
  disabled?: boolean;
}

/**
 * Pan slot component.
 * @public
 */
export const Pan = (props: PanSlotProps) => null;

Pan['displayName'] = 'HistogramChart.Pan';
